import React, { useState } from "react";
import { Card, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Header from "../components/header/Header";
import ProgressBar from "../components/progressBar/ProgressBar";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../redux/actions/CartActions";
import { updateBusinessRequest } from "../redux/actions/RequestActions";
import Swal from "sweetalert2";
import Loader from "../components/loader/Loader";

function AssociatedCreators() {
  const navigate = useNavigate();
  const currentStep = "Entreprise";
  const steps = [
    "Propriétaire",
    "Entreprise",
    "Services",
    "Paiement",
    "Finalisation",
  ];
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart);
  const { user } = useSelector((state) => state.authUser);
  const { businessCreationRequest } = useSelector((state) => state.request);
  const [submitting, setSubmitting] = useState(false);

  const handleSelection = async (associates) => {
    setSubmitting(true);
    await dispatch(
      addToCart({
        associates: associates,
      }),
    );
    await dispatch(
      updateBusinessRequest(
        user.token,
        businessCreationRequest.reference,
        {
          shareHolders: associates,
        },
        handleCallback,
      ),
    );
  };

  const handleCallback = ({ success, message }) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
    });
    if (success) {
      navigate("/sector-activity");
    } else {
      Toast.fire({
        icon: "error",
        title: "Échec",
        text: message,
      });
    }
    setSubmitting(false);
  };

  return (
    <div style={{ backgroundColor: "#fff", paddingBottom: "40px" }}>
      <Header />
      <ProgressBar steps={steps} currentStep={currentStep} />
      <Loader isLoading={submitting} />

      <div className="container mt-4 text-center">
        <h4 className="text-2xl font-semibold">
          Quel sera le nombre de{" "}
          <span style={{ color: "#FF5500" }}>créateurs associés</span> de votre{" "}
          {cart?.businessType} ?
        </h4>
        <p className="text-muted mt-3">
          Les créateurs sont les associés de la société. Ils contribuent au
          capital et détiennent les parts sociales de celle-ci.
        </p>
      </div>

      {/* Options Section with Two Large, Centered Boxes */}
      <div className="container mt-4 d-flex justify-content-center">
        <Row className="w-98 justify-content-center">
          <Col xs={12} sm={10} md={6} className="mb-4">
            <Card
              className="p-3 text-center"
              style={{
                cursor: "pointer",
                transition: "0.3s",
                border: `2px solid ${cart.associates === "2" ? "#FF5500" : "transparent"}`,
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                width: "200px",
                maxWidth: "300px",
                height: "150px",
                margin: "0 auto",
                justifyContent: "center",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = "#FF5500";
                e.currentTarget.style.color = "#fff";
                e.currentTarget.style.borderColor = "#FF5500";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#fff";
                e.currentTarget.style.color = "#000";
                e.currentTarget.style.borderColor =
                  cart.associates === "2" ? "#FF5500" : "transparent";
              }}
              onClick={() => handleSelection("2")}
            >
              <p style={{ color: "#000", fontSize: "1rem" }}>2 associés</p>
            </Card>
          </Col>

          <Col xs={12} sm={10} md={6} className="mb-4">
            <Card
              className="p-3 text-center"
              style={{
                cursor: "pointer",
                transition: "0.3s",
                border: `2px solid ${cart.associates === "Plus" ? "#FF5500" : "transparent"}`,
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                width: "200px",
                maxWidth: "300px",
                height: "150px",
                margin: "0 auto",
                justifyContent: "center",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = "#FF5500";
                e.currentTarget.style.color = "#fff";
                e.currentTarget.style.borderColor = "#FF5500";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#fff";
                e.currentTarget.style.color = "#000";
                e.currentTarget.style.borderColor =
                  cart.associates === "Plus" ? "#FF5500" : "transparent";
              }}
              onClick={() => handleSelection("Plus")}
            >
              <p style={{ color: "#000", fontSize: "1rem" }}>
                3 associés ou plus
              </p>
            </Card>
          </Col>
        </Row>
      </div>

      <div className="container mt-5 text-center">
        <h3 className="text-lg font-semibold mb-3">
          Qui peut être associé d'une entreprise ?
        </h3>
        <p className="text-muted">
          L'associé peut être un particulier (de nationalité Camerounaise ou
          étrangère) ou une société (immatriculée au Cameroun ou à l'étranger).
        </p>
      </div>
    </div>
  );
}

export default AssociatedCreators;
